var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('span',[_vm._v("ARTISTS")]),_c('div',{staticClass:"header_hover_menu"},[_c('router-link',{attrs:{"to":"/apply"}},[_vm._v("APPLY")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }